import { put, call } from 'redux-saga/effects'

import { BFFAgent } from '../../../../common/BFFAgent'
import {
  COMMISSIONS_CREATE_NEW_MONTH_SUCCESS,
  COMMISSIONS_CREATE_NEW_MONTH_FAILURE
} from '../constants'

export function* postCreateNewMonthlyCommissionSaga(action) {
  try {
      const {periodName, from, to, companyId} = action.data;
      yield call(BFFAgent.Commission.postCreateNewMonthlyCommission, periodName, from, to, companyId)

      yield put({
          type: COMMISSIONS_CREATE_NEW_MONTH_SUCCESS,
      })
      
  } catch (error) {
    yield put({
      type: COMMISSIONS_CREATE_NEW_MONTH_FAILURE,
      data: { error }
    })
  }
}
